// React
import React from 'react';

// Packages

// Utilities
import { useLabels, useActivityTagging } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ActivityMetrics,
    ActivityReflections,
    ActivityDetails,
    ActivityChoice,
    ActivityDataCard,
    ActivitySetFieldValues,
} from '../_common';
import { ActivityServiceDetails } from 'components/_cardContents/activityService/activityService';

const Name = CONSTANTS.ACTIVITIES.SERVICE;

const Choice = props => {
    return ActivityChoice({
        Name,
        methods: 'Initiative_Activity__c.Delivery_Method__c',
        fieldName: 'Delivery_Method__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ActivityDataCard
            {...{
                item,
                theme,
                tagTypes: [CONSTANTS.TAGS.UPGRADE_ACTIVITY],
                methodsFieldName: 'Delivery_Method__c',
                showTags: mode.includes('tags'),
                showDetails: mode.includes('details'),
            }}>
            <ActivityServiceDetails {...{ item, theme }} />
        </ActivityDataCard>
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, dataSet, label } = useLabels();
    const tagging = useActivityTagging({
        types: [CONSTANTS.TAGS.SERVICE_ACTIVITY],
    });

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { Delivery_Method__c, Initiative_Location__c } = formData;

        // Data for sf
        return {
            Delivery_Method__c,
            Initiative_Location__c: Initiative_Location__c?.map(
                item => item.selectValue
            ).join(';'),
        };
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        return [
            {
                type: 'SelectList',
                name: 'Initiative_Location__c',
                object: object.config(
                    'Initiative_Activity__c.Initiative_Location__c'
                ),
                buttonLabel: label('ButtonAddLocation'),
                listMaxLength: 8,
                options: dataSet('Countries'),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ActivityDetails({
        tagging: tagging.activity,
        fields,
        getItemData,
        ...props,
    });
};

const Metrics = props => {
    return ActivityMetrics({
        Name,
        primary: true,
        secondary: true,
        additional: true,
        ...props,
    });
};

const Reflections = props => {
    return ActivityReflections({
        primary: true,
        secondary: true,
        additional: true,
        ...props,
    });
};

const setFieldValues = ({
    tagging,
    choice,
    form,
    id,
    utilities,
    REPORT_ID,
}) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const {
        Delivery_Method__c,
        Initiative_Location__c,
    } = utilities.activities.get(id);

    // Choice
    form.setValue('Delivery_Method__c', Delivery_Method__c);

    // Country
    form.setValue(
        'Initiative_Location__c',
        Initiative_Location__c?.split(';').map(value => ({
            selectValue: value,
        }))
    );

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ActivitySetFieldValues({
        REPORT_ID,
        tagging,
        choice,
        form,
        id,
        utilities,
    });
};

export {
    Name,
    DataCard,
    Choice,
    Details,
    Metrics,
    Reflections,
    setFieldValues,
};
